import { useState } from "react";
import { useDebounce } from "use-debounce";

export default function useSearchTerm() {
  const [searchTerm, searchTermSet] = useState("");
  const [searchTermDebounced] = useDebounce(searchTerm, 300);
  return [searchTerm, searchTermSet, searchTermDebounced];
}
